import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { KomponentType } from "../model/komponent-type.model";

@Component({
    selector: "komponent-typer-dialog",
    templateUrl: "./komponent-typer-dialog.component.html",
    styleUrls: ["./komponent-typer-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KomponentTyperDialogComponent {
    constructor(public dialogRef: MatDialogRef<KomponentTyperDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

    public onVaelg(komponentType: KomponentType): void {
        this.dialogRef.close(komponentType);
    }
}
